export enum ConsumerAppSpace {
    OVERVIEW = 'overview',
    DETAILS = 'details',
    INTERACTIONS = 'interactions',
    NOTES = 'notes',
    EXTERNALDATA = 'externalData',
    TICKETS = 'tickets',
  }
  